<template>
<div>
  <svg class="c-counter__dial" version="1.1" xmlns="http://www.w3.org/2000/svg" :viewBox="dialViewBox">
    <circle class="c-counter__border" :cx="halfSize" :cy="halfSize" :r="radius"/>
    <circle class="c-counter__trail" :cx="halfSize" :cy="halfSize" :r="radius" :transform="trailTransform" :style="trailStyle"/>
    <circle class="c-counter__pointer" :cx="halfSize" :cy="pointerCY" :r="pointerRadius" :transform="pointerTransform"/>
  </svg>
</div>
</template>

<script>
export default {
  props: {
    small: {
      default: false,
      type: Boolean
    },
    percentage: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      actualPercent: 0
    }
  },
  watch: {
    percentage (value) {
      this.calculatePercentage()
    }
  },
  mounted () {
    this.calculatePercentage()
  },
  methods: {
    async calculatePercentage () {
      for (let i = 0; i < this.percentage; i++) {
        await new Promise(resolve => setTimeout(resolve, 20))
        this.actualPercent++
      }
    }
  },
  computed: {
    radius () {
      return this.small ? 26 : 50
    },
    size () {
      return this.small ? 60 : 110
    },
    halfSize () {
      return this.size / 2
    },
    calculateStroke () {
      return (2 * Math.PI * this.radius) - (2 * Math.PI * this.radius * this.actualPercent / 100)
    },
    dialViewBox () {
      return `0 0 ${this.size} ${this.size}`
    },
    trailTransform () {
      return `rotate(-90 ${this.size / 2} ${this.size / 2})`
    },
    trailStyle () {
      return `stroke-dashoffset:${this.calculateStroke}`
    },
    pointerCY () {
      return this.size / 2 - this.radius
    },
    pointerRadius () {
      return this.small ? 3 : 4
    },
    pointerTransform () {
      return `rotate(${this.actualPercent * 3.6} ${this.size / 2} ${this.size / 2})`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Counter.vue